<template>
  <button
    class="image-uploader-button btn btn-default"
    :class="{ active: props.isActive }"
    data-test="team-image-upload-button"
    @click="handleTileClick"
  >
    <input
      type="file"
      aria-label="Upload an image"
      ref="fileInput"
      style="display: none"
      accept="image/png, image/jpeg"
      @change="handleFileChange"
      data-test="image-upload-input"
    />
    <span v-if="!imageSrc" class="button-inner">
      <img src="../assets/image-upload.svg" alt="Upload an image" class="image-uploader-svg" />
      Images up to 4MB
    </span>
    <span v-else class="button-inner">
      <span class="team-image-container-sq">
        <img
          :src="imageSrc"
          alt="Selected image"
          class="image-uploader-svg"
          data-test="uploaded-image"
        />
      </span>
      <img
        src="../assets/image-upload.svg"
        alt="Upload an image"
        class="image-uploader-sm-icon"
        tabindex="0"
        @click="triggerFileInput"
        @keydown.enter="triggerFileInput"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{ isActive: boolean }>();

const imageSrc = ref<string | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);

const emit = defineEmits(["file-uploaded", "tile-selected"]);

const triggerFileInput = () => {
  fileInput.value?.click();
};

const handleTileClick = () => {
  if (!imageSrc.value) {
    triggerFileInput();
  } else {
    emit("tile-selected", imageSrc.value);
  }
};

// Handle file selection and display the image
const handleFileChange = () => {
  if (fileInput.value?.files && fileInput.value.files.length > 0) {
    const selectedFile = fileInput.value.files[0];

    // Use FileReader to get the data URL of the selected image
    const reader = new FileReader();
    reader.onload = (event) => {
      imageSrc.value = event.target?.result as string;
    };
    reader.readAsDataURL(selectedFile);
    emit("file-uploaded", selectedFile);
  }
};
</script>
<style scoped lang="less">
.image-uploader-svg {
  max-height: 100%;
  max-width: 100%;
}

.image-uploader-sm-icon {
  position: absolute;
  bottom: 2%;
  right: 2%;
  width: 22%;
  filter: saturate(0.5);

  &:hover {
    cursor: pointer;
    margin: 1px;
    filter: saturate(1) drop-shadow(1px 1px 1px black);
  }
}

.btn.image-uploader-button {
  //aspect-ratio: 1;
}

.btn.image-uploader-button {
  width: 100%;
  padding: 0;
  border-radius: 2px;
}

.button-inner {
  aspect-ratio: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  overflow: hidden;
}
</style>
